import { IVector3 } from 'src/sdk-components/SceneComponent';

export interface ITargetObjectData {
  isTag: boolean;
  id: string | null;
  sid: string;
  enableNavBar?: boolean;
  enableTeleportBtn?: boolean;
  autoNavigation?: boolean;
  navigationAutoPlay?: boolean;
  positionX: number;
  positionY: number;
  positionZ: number;
  webPathDescriptionEnabled?: boolean;
  tag?: Record<string, any>;
  station?: Record<string, any>;
}

export interface GetPathRequestSweep {
  id: string;
  sweepId: string;
  enabled: boolean;
  isCustom: boolean;
  position: IVector3;
  neighbors: string[];
}

export interface NavigationSweep {
  id: number;
  tourId: number;
  enabled: boolean;
  isCustom: boolean;
  name: string;
  positionX: number;
  positionY: number;
  positionZ: number;
  neighbourSweeps: string[];
  sweep_uuid: string;
  floor: number;
  sweepId: string;
  createdAt: string;
  updatedAt: string;
}

export interface CombinedSweep extends Omit<NavigationSweep, 'id'> {
  id: string;
  index: number | null;
  tourId: number;
  treedisId: number | null;
  createdAt: string;
  updatedAt: string;
  modifiedSweep: boolean;
}

export enum NavigationType {
  Shortest = 'shortest',
  NoElevators = 'noElevators',
  NoStairs = 'noStairs'
}

export type RequestFunction = (
  pathSweeps: any,
  startSID: string,
  endSID: string,
  tourId: any,
  navigationType: NavigationType
) => Promise<{ path: any[]; hasTeleports: boolean }>;

export interface NavigationManagerProps {
  iframe: any;
  tourId: number;
  pathCalculationSweeps: Map<string, CombinedSweep>;
  currentSweep: any;
  pathArrowRef: any;
  moveToSweep: any;
  teleportGroups: any;
  teleportPoints: any;
  showTeleportLoading: any;
  setActionPathNavbarPlayButtonType: any;
  requestFn: RequestFunction;
  handleTeleportClick: (sweep: any, resumeAfter: boolean, setStep: () => void) => Promise<void>;
}

export interface TeleportGroup {
  type: TeleportGroupType;
  id: number;
  tourId: number;
  name: string;
  enabled: boolean;
  points: TeleportPoint;
  createdAt: string;
  updatedAt: string;
}

export interface TeleportPoint {
  id: number;
  teleportGroupId: number;
  name: string;
  enabled: boolean;
  positionX: number;
  positionY: number;
  positionZ: number;
  createdAt: string;
  updatedAt: string;
  sweep: string;
}

export enum TeleportGroupType {
  Elevator = 'elevator',
  Stairway = 'stairway'
}

export interface TeleportPointComponent {
  type: TeleportGroupType;
  id: number;
  pointNodes: any;
}
